import { COMPACTA, PRINCIPAL, type Pieza } from './trazos'

/**
 * El logo de Agentical Group, desde los trazos de los vectores oficiales (marca/02-Vectores).
 *
 * El color sale de `currentColor`: negro sobre claro, hueso sobre oscuro, nunca otro (manual,
 * «Color»). El alto lo pone la clase y el ancho sale de la proporción; no se estira. El manual pide
 * 14 px de altura de mayúscula como mínimo: con estos recortes eso es `h-5` (20 px) para la compacta
 * y 22 px para la principal. Por debajo va el monograma, no el logo reducido (docs/marca.md).
 */
function Trazos({ pieza, className }: { pieza: Pieza; className?: string }) {
  return (
    <svg viewBox={pieza.viewBox} className={className} role="img" aria-label="Agentical Group" fill="currentColor">
      {pieza.trazos.map((d) => (
        <path key={d.slice(0, 24)} d={d} />
      ))}
    </svg>
  )
}

/** GROUP completo, en vertical. Por debajo de 22 px de alto se usa la compacta. */
export function LogoPrincipal({ className }: { className?: string }) {
  return <Trazos pieza={PRINCIPAL} className={className} />
}

/** Una línea con GRP: la de la barra superior. No menos de 20 px de alto. */
export function LogoCompacta({ className }: { className?: string }) {
  return <Trazos pieza={COMPACTA} className={className} />
}

/**
 * Adónde lleva «Volver al sitio»: el sitio de la empresa, que es la puerta desde la que se llega
 * al portal. En producción, agentical-group.com; en desarrollo, el 5170. VITE_URL_SITIO lo
 * sobrescribe para un ambiente de pruebas.
 */
export const URL_SITIO: string =
  import.meta.env.VITE_URL_SITIO ?? (import.meta.env.PROD ? 'https://agentical-group.com' : 'http://localhost:5170')
